import Swiper, { Navigation, Thumbs, Lazy } from "swiper";

const ProductGallery = {
    init() {

        const wrapEl = $(".product__gallery");
        if (!wrapEl.length) {
            return;
        }

        const thumbsSliderEl = wrapEl.find(".gallery-thumbs");
        const gallerySliderEl = wrapEl.find(".gallery-slider");

        var thumbsSwiper = new Swiper(thumbsSliderEl[0], {
            modules: [Thumbs],
            spaceBetween: 10,
            slidesPerView: "auto",

            freeMode: true,
            watchSlidesProgress: true,
        });

        var largeSwiper = new Swiper(gallerySliderEl[0], {
            modules: [Lazy, Navigation, Thumbs],
            slidesPerView: 1,
            spaceBetween: 16,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
        });
    },
};

export default ProductGallery;
